import React from 'react';
import { withRouter } from 'react-router';

import StepperItem from './StepperItem/StepperItem'

const Stepper = props => {
  
  const steps = [ 1, 2, 3, 4 ];

  const handleClick = num => {
    const nextPath = `${process.env.PUBLIC_URL}/step${num}`
    props.history.push(
      {
       pathname: nextPath,
      }
    )
  }

  const { activeNumber } = props;

  return (
    <div className="Stepper" >
      {steps.map(num => (
        <StepperItem
          key={num}
          num={num}
          active={num === activeNumber}
          onClick={() => handleClick(num)}
          disable={num > activeNumber}
        />
      ))}
    </div>
  );

};

export default withRouter(Stepper);
